export const buildGoogleInterstitialEligibilityAttributes = ({
  allowGoogleInterstitial = false,
} = {}) => ({
  'data-google-interstitial': allowGoogleInterstitial ? undefined : 'false',
  'data-google-vignette': allowGoogleInterstitial ? undefined : 'false',
});

export const GOOGLE_INTERSTITIAL_INELIGIBLE_ATTRIBUTES = Object.freeze(
  buildGoogleInterstitialEligibilityAttributes({
    allowGoogleInterstitial: false,
  })
);
